import { atom } from 'recoil';
import { IHistoricoAcoes } from '../../commons/types/acoes';

export const historicoAcoesAtom = atom<IHistoricoAcoes[]>({
  key: 'historicoAcoes',
  default: [] as IHistoricoAcoes[],
});
